import React, { createContext, useContext } from 'react';
import type { PlatformServices } from './types';

const PlatformServicesContext = createContext<PlatformServices | null>(null);

export function PlatformServicesProvider({
  children,
  services,
}: {
  children: React.ReactNode;
  services: PlatformServices;
}) {
  return (
    <PlatformServicesContext.Provider value={services}>
      {children}
    </PlatformServicesContext.Provider>
  );
}

export function usePlatformServices(): PlatformServices {
  const value = useContext(PlatformServicesContext);
  if (!value) {
    throw new Error('PlatformServicesProvider is missing');
  }
  return value;
}

